import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=2d2c1bfb"
import script from "./Package.vue?vue&type=script&lang=js"
export * from "./Package.vue?vue&type=script&lang=js"
import style0 from "./Package.vue?vue&type=style&index=0&id=2d2c1bfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports